export function arrayUnion<T>(arr1: T[], arr2: T[], equalityFunc: (compare1: T, compare2: T) => boolean): T[] {
  const union = arr1.concat(arr2);

  for (let i = 0; i < union.length; i++) {
    for (let j = i + 1; j < union.length; j++) {
      if (equalityFunc(union[i], union[j])) {
        union.splice(j, 1);
        j--;
      }
    }
  }

  return union;
}

export function flattenArray<T>(errors: T, prefix = ''): Record<string, string> {
  const flat: Record<string, string> = {};

  for (const key in errors) {
    const value = errors[key];
    const path = prefix ? `${prefix}.${key}` : key;

    if (typeof value === 'string') {
      flat[path] = value;
    } else if (typeof value === 'object' && value !== null) {
      Object.assign(flat, flattenArray(value, path));
    }
  }

  return flat;
}

export const formatStringArray = (values: string[]) => {
  if (!values || values.length === 0) return '';
  if (values.length === 1) return values[0];
  if (values.length === 2) return `${values[0]} and ${values[1]}`;
  return `${values.slice(0, -1).join(', ')} and ${values[values.length - 1]}`;
};
